"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
// This file is autogenerated by "make react_icons", do not edit it.
const React = tslib_1.__importStar(require("react"));
const Feather = (props) => React.createElement("svg", { className: "lucide lucide-feather", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", ...props },
    React.createElement("path", { d: "M12.67 19a2 2 0 001.416-.588l6.154-6.172a6 6 0 00-8.49-8.49L5.586 9.914A2 2 0 005 11.328V18a1 1 0 001 1zM16 8L2 22M17.5 15H9" }));
exports.default = Feather;
